var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "#E0E6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6602 18H15.3398C13.4945 18 12 19.5038 12 21.3398V41.3789C12 43.2258 13.5055 44.7188 15.3398 44.7188H46.6602C48.49 44.7188 50 43.2321 50 41.3789V21.3398C50 19.5071 48.5114 18 46.6602 18ZM46.1924 20.2266C45.5101 20.9053 33.7671 32.5864 33.3616 32.9897C32.7308 33.6206 31.8921 33.9679 31 33.9679C30.1079 33.9679 29.2692 33.6205 28.6363 32.9877C28.3636 32.7164 16.7502 21.1642 15.8076 20.2266H46.1924ZM14.2266 40.9257V21.7944L23.8481 31.3653L14.2266 40.9257ZM15.809 42.4922L25.4268 32.9356L27.064 34.5641C28.1153 35.6155 29.5132 36.1945 31 36.1945C32.4868 36.1945 33.8847 35.6155 34.934 34.5662L36.5732 32.9356L46.191 42.4922H15.809ZM47.7734 40.9257L38.1519 31.3653L47.7734 21.7944V40.9257Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.788ad528ba789e180c0ddfe1c27609cd.svg";
export { ForwardRef as ReactComponent };